import { BoxSpg } from "@duosoftbg/nacid-components";
import React from "react";
import styled from "styled-components";

const IconWrapper = styled(BoxSpg)<{ showServiceContainer: boolean }>`
  cursor: pointer;
  display: flex;
  padding: 8px 8px 40px;
  z-index: 1;
  position: relative;
  box-sizing: border-box;
  min-height: 185px;
  align-items: center;
  flex-direction: column;
  text-decoration: none;

  .icon-text {
    color: ${(props) => (props.showServiceContainer ? "#0054a4" : "#000")};
  }

  :hover {
    .icon-text {
      color: #0054a4;
    }
  }
`;

const Arrow = styled.div`
  top: calc(100% - 40px);
  left: calc(50% - 22px);
  z-index: 3;
  position: absolute;
  transition:
    all 0.1s ease-out,
    transform 0.2s ease-out;
  animation-name: jss21419;
  animation-duration: 0.1s;

  svg {
    fill: currentColor;
    width: 1em;
    height: 1em;
    display: inline-block;
    font-size: 1.5rem;
    transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    flex-shrink: 0;
    -moz-user-select: none;
  }

  #path1 {
    fill: #0054a4;
  }

  #path2 {
    fill: #fafafa;
  }

  #path3 {
    fill: none;
  }
`;

const IconText = styled(BoxSpg)`
  width: 100%;
  font-size: 16px;
  max-width: 180px;
  margin-top: 23px;
  text-align: center;
`;

const Icon = styled(BoxSpg)`
  //width: 64px;
  //height: 64px;
  //
  //svg {
  //  width: 64px;
  //  height: 64px;
  //}
`;

const CategoryIcon = ({ svgIconComponent, onClick, showServiceContainer, title }) => {
  return (
    <IconWrapper onClick={onClick} showServiceContainer={showServiceContainer}>
      <Icon>{svgIconComponent}</Icon>
      <IconText className={"icon-text"}>{title}</IconText>
      {showServiceContainer && (
        <Arrow>
          <svg
            viewBox="0 0 44 44"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            style={{ width: 44, height: 44 }}
          >
            <path id="path1" d="M0 0h28L0 28z" data-name="Path 1944" transform="rotate(45 10.886 26.622)"></path>
            <path id="path2" d="M0 0H30V30H0z" data-name="Rectangle 471" transform="rotate(-45 27.799 10.383)"></path>
            <path id="path3" d="M0 0H44V44H0z"></path>
          </svg>
        </Arrow>
      )}
    </IconWrapper>
  );
};

export default CategoryIcon;
